// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__22Nuc","paramInput":"JobSimulator_paramInput__1_lqv","input":"JobSimulator_input__1hdD_"};